'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        scrollableDistance: {
            type: Number,
            kComposite: 'scrollable.distance'
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-layout-vue-wrapper/dist/es/Common/Scrollable.js
// module id = 275
// module chunks = 0